export default __webpack_public_path__ + "static/media/331.5f56459a.gif";